import { Menu } from './menu.model';

export const verticalMenuItems = [ 
    new Menu (1, 'Crear despliegue', '/', "/", 'desktop', null, false, 0),
    new Menu (2, 'Histórico', 'history', null, 'history', null, false, 0),
    new Menu (3, 'Carga predictiva', 'predictive', null, 'magic', null, false, 0),
]

export const horizontalMenuItems = [ 
]